(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, global.UnionReplacer = factory());
}(this, (function () { 'use strict';

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) {
      _construct = Reflect.construct;
    } else {
      _construct = function _construct(Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
      };
    }

    return _construct.apply(null, arguments);
  }

  var createStringReplacer = function createStringReplacer(replacementStr) {
    return function stringReplacer(ctx) {
      var m = ctx.match;
      var groups = m.groups || {};
      return replacementStr.replace(/\$([1-9]\d*)|\$([&`'$])|\$<([^\d\s>][^\s>]*)>/g, function (s, capture, special, namedCapture) {
        if (capture && +capture < m.length) {
          return m[+capture];
        }

        if (special) {
          switch (special) {
            case '$':
              return '$';

            case '&':
              return m[0];

            case '`':
              return m.input.slice(0, m.index);

            case "'":
              return m.input.slice(m.index + m[0].length);

            default:
              throw new Error();
          }
        }

        if (namedCapture && namedCapture in groups) {
          return groups[namedCapture];
        }

        return s;
      });
    };
  };

  var wrapStringReplaceFn = function wrapStringReplaceFn(replacementFn) {
    return function callStringReplaceFn(ctx) {
      var m = ctx.match;
      var info = m.groups ? [m.index, m.input, m.groups] : [m.index, m.input];
      return replacementFn.apply(this, [].concat(m, info));
    };
  };

  var UnionReplacerElement = function () {
    function UnionReplacerElement(pattern, replacement, extended) {
      if (pattern.constructor !== RegExp) {
        throw new TypeError("Replacement pattern " + pattern + " is not a RegExp.");
      }

      this.pattern = pattern;

      if (typeof replacement === 'function') {
        this.replacementFn = extended ? replacement : wrapStringReplaceFn(replacement);
      } else {
        var replacementStr = String(replacement);
        this.replacementFn = createStringReplacer(replacementStr);
      }
    }

    var _proto = UnionReplacerElement.prototype;

    _proto.compile = function compile(captureNum) {
      var _this = this;

      var captureCount = 0;
      var parts = /(\(\?<)(?=[^!=])|(\()(?!\?)|\\([1-9]\d*)|\\[\s\S]|\[(?:[^\\\]]|\\[\s\S])*\]/g;
      var patternStr = this.pattern.source.replace(parts, function (match, parenNamed, paren, backref) {
        if (paren || parenNamed) {
          captureCount++;
        } else if (backref) {
          if (+backref > captureCount) {
            throw new SyntaxError("Octal or backreference to undefined capture group " + backref + " in " + _this.pattern);
          }

          return "\\" + (+backref + captureNum);
        }

        return match;
      });
      this.captureNum = captureNum;
      this.capturePatternStr = "(" + patternStr + ")";
      this.captureCount = captureCount + 1;
    };

    _proto.narrowMatch = function narrowMatch(ctx, totalCaptures) {
      var m0 = ctx.match;
      var m1 = m0.slice(this.captureNum, this.captureNum + this.captureCount);
      m1.index = m0.index;
      m1.input = m0.input;
      m1.groups = m0.groups;
      ctx.match = m1;
    };

    return UnionReplacerElement;
  }();

  var ReplacementStringBuilder = function () {
    function ReplacementStringBuilder() {
      this.output = '';
    }

    var _proto = ReplacementStringBuilder.prototype;

    _proto.addSubjectSlice = function addSubjectSlice(subject, start, end) {
      this.output += subject.slice(start, end);
    };

    _proto.addReplacedString = function addReplacedString(string) {
      this.output += string;
    };

    _proto.build = function build() {
      return this.output;
    };

    return ReplacementStringBuilder;
  }();

  var emptyMatchAdvance = function emptyMatchAdvance(input, index, unicode) {
    if (!unicode || index < 0 || index + 1 >= input.length) {
      return 1;
    }

    var c1 = input.charCodeAt(index);

    if (c1 < 0xD800 || c1 > 0xDBFF) {
      return 1;
    }

    var c2 = input.charCodeAt(index + 1);
    return c2 < 0xDC00 || c2 > 0xDFFF ? 1 : 2;
  };

  var MatchingContext = function () {
    function MatchingContext(replacer) {
      this.replacer = replacer;
      this.match = null;
      this.lastIndex = 0;
    }

    var _proto = MatchingContext.prototype;

    _proto.skip = function skip(n) {
      this.lastIndex = this.match.index + this.match[0].length + n;
    };

    _proto.jump = function jump(n) {
      this.lastIndex = this.match.index + n;
    };

    _proto.reset = function reset() {
      var index = this.match.index;
      var mlen = this.match[0].length;
      this.lastIndex = index + (mlen > 0 ? mlen : emptyMatchAdvance(this.match.input, index, this.replacer.regexp.unicode));
    };

    _proto.atStart = function atStart() {
      return this.match && this.match.index === 0;
    };

    _proto.atEnd = function atEnd() {
      var match = this.match;
      return match && match.index + match[0].length >= match.input.length;
    };

    return MatchingContext;
  }();

  var countCaptureGroups = function countCaptureGroups(elements) {
    return elements.reduce(function (num, element) {
      return num + element.captureCount;
    }, 0);
  };

  var findMatchingElementEs6 = function findMatchingElementEs6(elements, fullMatch) {
    return elements.find(function (element) {
      return fullMatch[element.captureNum] !== undefined;
    });
  };

  var findMatchingElementEs5 = function findMatchingElementEs5(elements, fullMatch) {
    for (var i = 0; i < elements.length; i++) {
      var element = elements[i];

      if (fullMatch[element.captureNum] !== undefined) {
        return element;
      }
    }

    return undefined;
  };

  var findMatchingElement = Array.prototype.find ? findMatchingElementEs6 : findMatchingElementEs5;

  function compile() {
    this.totalCaptureGroups = countCaptureGroups(this.elements);
    var regexpStr = this.elements.length > 0 ? this.elements.map(function (element) {
      return element.capturePatternStr;
    }).join('|') : '^[^\\s\\S]';
    this.regexp = new RegExp(regexpStr, this.flags);
  }

  var UnionReplacer = function () {
    function UnionReplacer(replaces, flags) {
      var _this = this;

      if (flags === void 0) {
        flags = 'gm';
      }

      this.flags = flags;
      this.elements = [];
      replaces.forEach(function (replace) {
        var element = _construct(UnionReplacerElement, replace);

        element.compile(countCaptureGroups(_this.elements) + 1);

        _this.elements.push(element);
      });
      compile.call(this);
    }

    var _proto = UnionReplacer.prototype;

    _proto.compile = function compile() {};

    _proto.replace = function replace(subject, userCtx, builder) {
      if (userCtx === void 0) {
        userCtx = {};
      }

      if (builder === void 0) {
        builder = new ReplacementStringBuilder();
      }

      var ctx = new MatchingContext(this);
      var savedLastIndex = this.regexp.lastIndex;

      try {
        this.regexp.lastIndex = 0;
        var prevLastIndex = 0;

        while ((ctx.match = this.regexp.exec(subject)) !== null) {
          var element = findMatchingElement(this.elements, ctx.match);
          element.narrowMatch(ctx, this.totalCaptureGroups);
          ctx.reset();
          builder.addSubjectSlice(subject, prevLastIndex, ctx.match.index, ctx, userCtx);
          var replaced = element.replacementFn.call(userCtx, ctx);
          builder.addReplacedString(replaced, ctx, userCtx);
          prevLastIndex = Math.min(ctx.match.index + ctx.match[0].length, ctx.lastIndex);
          this.regexp.lastIndex = ctx.lastIndex;

          if (!this.regexp.global) {
            break;
          }
        }

        builder.addSubjectSlice(subject, prevLastIndex, subject.length, ctx, userCtx);
        return builder.build();
      } finally {
        this.regexp.lastIndex = savedLastIndex;
      }
    };

    return UnionReplacer;
  }();

  return UnionReplacer;

})));
